<div class="login-body">
  <p-toast key="top" position="top-center">
  </p-toast>
  <div class="login-panel">
    <div class="flex-col">
      <div class="login-header">
        <img class="login-logo" [src]="app.getLogoLoginPngUrl()" />
        <h1>Passwort vergessen</h1>
        <h2>{{app.appName}}</h2>
      </div>
      @if (errorMessage != null) {
        <p-message severity="error">{{errorMessage}}</p-message>
      }
      @if (errorMessage == null) {
        <sm-form [form]="form">
        </sm-form>
      }
      <div>
        @if (errorMessage == null) {
          <p-button styleClass="width100p" icon="fas fa-sign-in" [label]="userName == null ? 'Weiter' : 'Abschließen'" [disabled]="running || done" [loading]="running" (onClick)="send()">
          </p-button>
        }
        @if (errorMessage != null && app.mainConfig.authRules.canRevokePassword && app.mainConfig.authRules.revokePasswordPerEmailIfSet) {
          <p-button styleClass="width100p" icon="fas fa-envelope" label="Neuen Link anfordern" (onClick)="requestNewLink()">
          </p-button>
        }
      </div>
    </div>
  </div>
